<template>
    <div class="wrapper-editor-text mt-5">
        <v-row v-if="demandFilesPreview && demandFilesPreview.length > 0" class="d-flex justify-start">
            <v-col cols="2" v-for="file in demandFilesPreview" :key="file.index">
                <file-info :file="file.file" :id="file.objectId" :type="'observation'" :clearFile="clearFile"/>
            </v-col>
        </v-row>
        <editor-observation v-if="!isEdit" v-model="comment" :color="'#E0E0E0'" :background="true" :files="addDemandFiles" :multipleFiles="true"/>
        <editor-observation v-else-if="!isExtern && (isEmployee && isEdit)" v-model="comment" :color="'#E0E0E0'" :background="true" :multipleFiles="true"/>
        <read-only v-else :text="comment" :color="'#E0E0E0'" :observation="true"/>
    </div>
</template>

<script>
import FileInfo from '@/components/FileInfo'
import EditorObservation from '@/components/EditorObservation'
import ReadOnly from '@/components/ReadOnly'

export default {
    name: 'observation',
    components: {
        FileInfo,
        EditorObservation,
        ReadOnly
    },
    props: ['value', 'isEdit', 'isExtern'],
    data () {
        return {
            comment: null,
            demandFilesPreview: [],
            files: []
        }
    },
    methods: {
        async addDemandFiles (event) {
            for (let i = 0; event.target.files.length > i; i++) {
                const file = event.target.files[i]
                const tempFile = file.slice(0, file.size)
                const newFile = new File([tempFile], file.name.replace(/[^a-zA-Z._0-9]/g, ''))
                this.demandFilesPreview.push({ file: newFile })
                this.value.files.push({ file: newFile })
            }
        },
        clearFile (value) {
            this.demandFilesPreview = this.demandFilesPreview.filter((f) => f.file.name !== value)
            this.value.files = this.value.files.filter((f) => f.file.name !== value)
        }
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    watch: {
        comment () {
            this.value.comments = this.comment
        },
        value () {
            this.demandFilesPreview = this.value.files
            this.comment = this.value.comments
        }
    }
}
</script>
